import { computed, toValue } from "vue";
import { FormFieldContextKey } from "../Symbols.mjs";
import { injectWithSelf } from "../utils.mjs";
function useGetFieldValue() {
  const { value } = injectWithSelf(FormFieldContextKey, {});
  return computed(() => toValue(value));
}
export {
  useGetFieldValue as default
};
//# sourceMappingURL=useGetFieldValue.mjs.map
